import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getOrgList = createAsyncThunk("/get-organisation", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}organisation/api/v1/get-organisation`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("Organisation response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    // console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Organisation");
  }
});
